import {computed, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {SearchTypeExpiration, TSearchTypeExpiration} from './constants';
import {expirationRuleDefaults} from './defaults';
import type {ExpirationRule} from './types';
import {validateExpirationRule} from './validate';

export class ExpirationRuleModel
	extends RuleModel<TSearchTypeExpiration>
	implements ExpirationRule
{
	readonly elementType = SearchTypeExpiration;
	elementSubType1: 0 = expirationRuleDefaults.elementSubType1;
	elementSubType2: 0 = expirationRuleDefaults.elementSubType2;
	elementValue1: '' = expirationRuleDefaults.elementValue1;
	elementValue2: '' = expirationRuleDefaults.elementValue2;
	elementValue3: '' = expirationRuleDefaults.elementValue3;

	get isValid() {
		return validateExpirationRule(this);
	}

	constructor(params?: Partial<Omit<ExpirationRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...expirationRuleDefaults, ...params});
		});

		makeObservable(this, {
			isValid: computed,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/** stubbed */
	setElementValue1() {}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default ExpirationRuleModel;
